module.exports = __webpack_public_path__ + "static/media/mirror 4.84a5fb52.jpg";